import React, { FC } from 'react';
import stringHelpers from '../../../utils/stringHelpers';
import { Text, View } from 'react-native';
import styles from './styles';
import { WIDGET_TEXT } from './constants';

export type SpotifyPreviewProps = {
  id: string;
  width?: string;
  height?: string;
};

export const SpotifyPreviewTrack: FC<SpotifyPreviewProps> = (props) => {
  let { id = '', width = '300', height = '80' } = props;
  let parsedUri = id && stringHelpers.updateToUri(id);
   return (
    <View style={styles.container}>
      {!id && (
        <View style={styles.widgetContainer}>
          <Text style={styles.text}>{WIDGET_TEXT}</Text>
        </View>
      )}
      {!!parsedUri && (
        <iframe
          allow="encrypted-media"
          //@ts-ignore
          allowtransparency="true"
          frameBorder="0"
          height={height}
          src={`https://embed.spotify.com/?uri=${parsedUri}`}
          width={width}
        />
      )}
    </View>
  );
};

export default SpotifyPreviewTrack;
